/**
 * Solo correo recordado en este dispositivo (opción “recordar”).
 * No persistir contraseñas ni tokens; la sesión sigue en AuthSessionService.
 *
 * El cierre de sesión no borra esta clave por defecto (conveniencia de usuario).
 */
const REMEMBERED_EMAIL_KEY = 'mandu.login.rememberedEmail';

export function readRememberedEmail(): string | null {
  const raw = localStorage.getItem(REMEMBERED_EMAIL_KEY);
  const trimmed = raw?.trim();
  return trimmed ? trimmed.toLowerCase() : null;
}

export function writeRememberedEmail(email: string): void {
  const normalized = email.trim().toLowerCase();
  if (!normalized) {
    return;
  }
  localStorage.setItem(REMEMBERED_EMAIL_KEY, normalized);
}

export function clearRememberedEmail(): void {
  localStorage.removeItem(REMEMBERED_EMAIL_KEY);
}
